import React from 'react'

import { format } from 'date-fns'

import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import styles from './requestPayment.module.scss'
import sessionResetDate from '../common/content/sessionResetDate'

const SessionsExceededModal = ({ firstName, lastName, company }: SessionsExceededModalProps) => {
  return (
    <div className={styles['modal-content']}>
      <h2 className={styles['main-header']}>Invoice not submitted</h2>
      <div>
        <p>
          Your invoice dated {format(new Date(), 'MMMM d, yyyy')} for client{' '}
          <span className={styles.capitalize}>{firstName}</span> <span className={styles.capitalize}>{lastName}</span>{' '}
          was not processed because <span className={styles.capitalize}>{firstName}</span> doesn’t have any more covered
          sessions remaining as part of their Lyra benefit. Unfortunately, Lyra is unable to reimburse for any
          additional visits for this client.{' '}
          {sessionResetDate({ employer: company?.label, date: company?.session_count_starts_on })}
        </p>
        <p className='paragraph-small'>
          For any questions, please contact <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
        </p>
      </div>
    </div>
  )
}

type SessionsExceededModalProps = {
  firstName: string
  lastName: string
  company?: CustomerInfo
}

export default SessionsExceededModal
